import { PageLoader } from '@/components'
import { AuthenticatedOutlet } from '@/providers'
import { useCurrentPatient } from '@/services'
import { Navigate } from 'react-router-dom'

export const ImportantDocumentsEnabledGuard = () => {
  const { data, isLoading } = useCurrentPatient()

  if (isLoading) return <PageLoader />

  // `=== false`: ein fehlendes Feld (aelteres Backend) darf den Bereich nicht deaktivieren.
  if (data?.important_documents_enabled === false) return <Navigate to="../dashboard" replace />

  // AuthenticatedOutlet (statt Outlet), damit der über useOutletContext
  // weitergereichte Auth-Kontext nicht abreißt – sonst crasht die Kindseite.
  return <AuthenticatedOutlet />
}
